<template>
    <div id="app">
        <router-view />
    </div>
</template>

<script>
import Vue from 'vue';

import filters from './filters/_filters';

import userService from './services/user.service';
import clientService from './services/client.service';
import currencyService from './services/currency.service';
import timezoneService from './services/timezone.service';

import state from './state';

/* global components */
import LinkInfo from './components/common/content/link/link-info.vue';
Vue.component('LinkInfo', LinkInfo)

export default {
    name: 'app',
    async mounted() {
        var adm = await userService.get();
        if (adm) state.admin.set(adm);
        await clientService.ensure();
        await currencyService.ensure();
        await timezoneService.ensure();
    }
};
</script>

<style lang="scss" src="./main.scss"></style>



// WEBPACK FOOTER //
// front/src/App.vue